import { TemplateRef } from '@angular/core';
import { FilterValues } from './filters';

interface BaseColumn {
  label: string;
  value: string;
  tooltipField?: string;
  hideForRoles?: string[];
  class?: string;
}

export enum Status {
  WARNING = 'warning',
  SUCCESS = 'success',
  DANGER = 'danger',
  PINK = 'pink',
  BLUE = 'blue',
  GRAY = 'gray',
}

export enum DateTemplate {
  DATE,
  UPDATED_DATE,
}

export type ColumnStatus = Record<string, Status>;

interface ActionColumn extends BaseColumn {
  type: ColumnType.ACTION;
  actions: Action[];
}

interface WithAvatarColumn extends BaseColumn {
  type: ColumnType.WITH_AVATAR;
  name_path: string;
}

interface DateColumn extends BaseColumn {
  type: ColumnType.DATE;
  template?: DateTemplate;
}

interface CustomColumn extends BaseColumn {
  type: ColumnType.CUSTOM;
  template: TemplateRef<any>;
  copyable?: never;
}

interface StatusColumn extends BaseColumn {
  type: ColumnType.STATUS;
  status: ColumnStatus;
}

interface SelectColumn extends BaseColumn {
  type: ColumnType.SELECT;
  options: FilterValues;
  placeholder: string;
  onChange?: (row: any, value: any) => void;
}

interface NonActionColumn extends BaseColumn {
  type?: Exclude<
    ColumnType,
    | ColumnType.ACTION
    | ColumnType.WITH_AVATAR
    | ColumnType.STATUS
    | ColumnType.DATE
    | ColumnType.CUSTOM
  >;
  actions?: never;
  copyable?: boolean;
  toggleKey?: string;
}

export type Column =
  | ActionColumn
  | NonActionColumn
  | WithAvatarColumn
  | StatusColumn
  | SelectColumn
  | DateColumn
  | CustomColumn;

export enum ColumnType {
  WITH_AVATAR = 'avatar',
  DATE = 'date',
  STATUS = 'status',
  ACTION = 'action',
  SELECT = 'select',
  TOOGLE = 'toogle',
  CUSTOM = 'custom',
}

interface Action {
  label: TableActions;
  icon: string;
  class?: string;
  isHidden?: string;
}

export interface ActionClick {
  label: TableActions;
  data: any;
}

export enum TableActions {
  VIEW = 'View',
  PREVIEW = 'Preview',
  EDIT = 'Edit',
  RETRIGGER = 'Retrigger',
  PERMISSIONS = 'Permissions',
  DELETE = 'Delete',
  RENAME = 'Rename',
  PRINT = 'Print',
  DOWNLOAD = 'Download',
  COPY = 'Copy',
  CONFIRM = 'Confirm',
  REJECT = 'Reject',
  VOID = 'Void',
  CANCLE = 'Cancle',
  RESET_PASSWORD = 'Reset Password',
  TOOGLE = 'toogle',
  MANAGE_WALLET = 'Manage Wallet',
  BLOCK = 'Block',
  UNBLOCK = 'Unblock',
  SHOW = 'Show',
  CHANGE_PASSWORD = 'Change Password',
  VERIFY = 'Verify',
  ROTATE = 'Rotate',
}

export interface PageChange {
  page: number;
  perPage: number;
}

export const PAGE_SIZES = [10, 20, 50, 100, 200];

export const COLUMN_STATUS_CLASS = {
  warning: 'bg-yellow-100 text-yellow-800',
  success: 'bg-green-100 text-green-800',
  danger: 'bg-red-100 text-red-800',
  pink: 'bg-pink-100 text-pink-800',
  blue: 'bg-blue-100 text-blue-800',
  gray: 'bg-gray-300 text-gray-800',
};

export interface TableParams extends FilterValues {
  page: number;
  perPage: number;
}
